import styled from "styled-components";
import { TitleContainer } from "app/components/React/Widgets/WidgetsTop";
import { colorsPalettes } from "@similarweb/styles";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const TitleContainerStyled = styled(TitleContainer)`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    padding: 24px 14px 20px 24px;
    > div:first-child {
        margin-bottom: 8px;
    }
`;

export const CardBodyWrapper = styled(CenteredFlexRow)`
    height: 220px;
    > * {
        /* give space between items */
        width: calc(50% - 12px);
    }

    .swReactTableCell {
        height: 38px;
    }
`;
